<div class="pricing-calculator-container min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white">
  <div class="container mx-auto px-4 py-16">
    <!-- Header Section -->
    <div class="text-center mb-12">
      <h1 class="text-4xl md:text-5xl font-bold text-white mb-4">
        Professional <span class="text-blue-400">Pricing Calculator</span>
      </h1>
      <p class="text-xl text-slate-300 max-w-3xl mx-auto">
        Estimate your cloud costs based on your specific requirements. Add multiple plans to create a comprehensive quote.
      </p>
    </div>

    <!-- Main Calculator Section -->
    <div class="bg-slate-900/70 rounded-xl shadow-2xl p-6 border border-slate-700/70 mb-8 backdrop-blur-sm">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <!-- Service Type Selection -->
        <div>
          <label class="block text-sm font-medium text-slate-200 mb-2">Service Type</label>
          <div class="space-y-2">
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedServiceType === 'compute' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateServiceType('compute')">
              Compute
            </button>
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedServiceType === 'storage' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateServiceType('storage')">
              Storage
            </button>
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedServiceType === 'database' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateServiceType('database')">
              Database
            </button>
          </div>
        </div>

        <!-- Compute-specific selections (only show when service type is compute) -->
        <div *ngIf="calculator.selectedServiceType === 'compute'">
          <label class="block text-sm font-medium text-slate-200 mb-2">Instance Type</label>
          <div class="space-y-2">
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedInstanceType === 'Shared CPU' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateCalculatorInstanceType('Shared CPU')">
              Shared CPU
            </button>
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedInstanceType === 'Dedicated CPU' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateCalculatorInstanceType('Dedicated CPU')">
              Dedicated CPU
            </button>
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedInstanceType === 'High Memory' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateCalculatorInstanceType('High Memory')">
              High Memory
            </button>
          </div>
        </div>
        
        <!-- OS Selection (only show when service type is compute) -->
        <div *ngIf="calculator.selectedServiceType === 'compute'">
          <label class="block text-sm font-medium text-slate-200 mb-2">Operating System</label>
          <div class="space-y-2">
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedOS === 'linux' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateCalculatorOS('linux')">
              Linux
            </button>
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedOS === 'windows' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateCalculatorOS('windows')">
              Windows
            </button>
          </div>
        </div>
        
        <!-- Billing Cycle Selection -->
        <div>
          <label class="block text-sm font-medium text-slate-200 mb-2">Billing Cycle</label>
          <div class="space-y-2">
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedBilling === 'hourly' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateCalculatorBilling('hourly')">
              Hourly
            </button>
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedBilling === 'monthly' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateCalculatorBilling('monthly')">
              Monthly
            </button>
            <button 
              class="w-full px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border"
              [ngClass]="calculator.selectedBilling === 'yearly' ? 'bg-blue-600 text-white shadow-blue-500/30 border-blue-500/80' : 'bg-slate-900/60 text-slate-200 border-slate-700/70 hover:bg-slate-800/70'"
              (click)="updateCalculatorBilling('yearly')">
              Yearly
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- All Available Plans Section -->
    <div class="bg-slate-900/70 rounded-xl shadow-2xl p-6 border border-slate-700/70 mb-8 backdrop-blur-sm">
      <h2 class="text-2xl font-bold text-white mb-4">Available Plans</h2>
      <div class="flex items-center gap-3 mb-6">
        <div class="flex-1">
          <input
            type="text"
            [(ngModel)]="searchQuery"
            placeholder="Search by name or configuration"
            class="w-full px-4 py-2 border border-slate-700 rounded-lg bg-slate-950/70 text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div class="flex items-center gap-2">
          <div class="flex items-center gap-2">
            <label class="text-sm text-slate-300">vCPU</label>
            <input
              type="number"
              min="0"
              step="1"
              [(ngModel)]="filterVcpuExact"
              class="w-20 px-3 py-2 border border-slate-700 rounded-lg bg-slate-950/70 text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            />
          </div>
          <div class="flex items-center gap-2">
            <label class="text-sm text-slate-300">RAM (GB)</label>
            <input
              type="number"
              min="0"
              step="4"
              [(ngModel)]="filterRamExactGB"
              class="w-24 px-3 py-2 border border-slate-700 rounded-lg bg-slate-950/70 text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            />
          </div>
        </div>
        <button
          class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300"
          [ngClass]="compareSelection.length >= 2 ? 'bg-indigo-600 text-white shadow-indigo-500/30' : 'bg-slate-900/60 text-slate-300 border border-slate-700/70'"
          [disabled]="compareSelection.length < 2"
          (click)="openCompare()">
          Compare ({{ compareSelection.length }})
        </button>
        <div class="hidden md:flex items-center text-sm text-slate-400">
          <i class="bx bx-info-circle mr-1"></i>
          Tip: try “8 GB”, “NVMe”, “MySQL”
        </div>
      </div>
      
      <!-- Storage Plan Categories (only show when service type is storage) -->
      <div class="mb-6" *ngIf="calculator.selectedServiceType === 'storage'">
        <h3 class="text-lg font-semibold text-slate-100 mb-3">Storage Categories</h3>
        <div class="flex flex-wrap gap-2">
          <span class="px-4 py-2 rounded-lg text-sm font-medium bg-blue-100 text-blue-800 border border-blue-300">
            Block Storage
          </span>
          <span class="px-4 py-2 rounded-lg text-sm font-medium bg-green-100 text-green-800 border border-green-300">
            Object Storage
          </span>
          <span class="px-4 py-2 rounded-lg text-sm font-medium bg-purple-100 text-purple-800 border border-purple-300">
            Archive Storage
          </span>
        </div>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div *ngFor="let plan of getFilteredAvailablePlans()" 
             class="border rounded-lg p-4 hover:shadow-xl transition-shadow duration-300 bg-slate-900/60 border-slate-700/60"
             [ngClass]="calculator.selectedPlan === plan.name ? 'border-blue-500/80 bg-blue-950/40 shadow-blue-500/30' : 'border-slate-700/60'">
          <div class="flex justify-between items-start">
            <div class="flex items-center gap-2">
              <h3 class="text-lg font-bold text-slate-100">{{ plan.name }}</h3>
              <span *ngIf="getPlanBadge(plan) === 'best'" class="px-2 py-1 text-xs rounded-full bg-green-500/20 text-green-300 border border-green-400/60">
                Best Value
              </span>
              <span *ngIf="getPlanBadge(plan) === 'popular'" class="px-2 py-1 text-xs rounded-full bg-amber-500/20 text-amber-200 border border-amber-400/60">
                Popular Choice
              </span>
            </div>
            <ng-container>
              <span *ngIf="getAnnualSavings(plan).percent > 0" class="bg-indigo-500/20 text-indigo-200 text-xs px-2 py-1 rounded-full border border-indigo-400/60">
                Save {{ getAnnualSavings(plan).percent }}% annually
              </span>
            </ng-container>
          </div>
          
          <!-- Compute Plan Details -->
          <div class="mt-3 space-y-2" *ngIf="plan.serviceType === 'compute'">
            <div class="flex justify-between" *ngIf="plan.vcpu">
              <span class="text-slate-300">vCPU:</span>
              <span class="font-medium text-slate-100">{{ plan.vcpu }}</span>
            </div>
            <div class="flex justify-between" *ngIf="plan.ram">
              <span class="text-slate-300">RAM:</span>
              <span class="font-medium text-slate-100">{{ plan.ram }}</span>
            </div>
            <div class="flex justify-between" *ngIf="plan.storage">
              <span class="text-slate-300">Storage:</span>
              <span class="font-medium text-slate-100">{{ plan.storage }}</span>
            </div>
            
            <!-- Minimum Billing Notice -->
            <div class="mt-3 p-3 bg-red-950/40 border border-red-500/70 rounded-lg" *ngIf="plan.minimumBilling">
              <p class="text-xs font-semibold text-red-300 leading-relaxed">
                <i class="bx bx-info-circle mr-1"></i>
                Minimum Billing: ₹{{ plan.minimumBilling }} applicable for this plan.
              </p>
            </div>
          </div>
          
          <!-- Storage Plan Details -->
          <div class="mt-3 space-y-2" *ngIf="plan.serviceType === 'storage'">
            <div class="flex justify-between" *ngIf="plan.storage">
              <span class="text-slate-300">Storage:</span>
              <span class="font-medium text-slate-100">{{ plan.storage }}</span>
            </div>
            <div class="flex justify-between" *ngIf="plan.diskType">
              <span class="text-slate-300">Type:</span>
              <span class="font-medium text-slate-100">{{ plan.diskType }}</span>
            </div>
            <div class="flex justify-between" *ngIf="plan.iops">
              <span class="text-slate-300">IOPS:</span>
              <span class="font-medium text-slate-100">{{ plan.iops }}</span>
            </div>
            <div class="flex justify-between" *ngIf="plan.throughput">
              <span class="text-slate-300">Throughput:</span>
              <span class="font-medium text-slate-100">{{ plan.throughput }}</span>
            </div>
          </div>
          
          <!-- Database Plan Details -->
          <div class="mt-3 space-y-2" *ngIf="plan.serviceType === 'database'">
            <div class="flex justify-between" *ngIf="plan.dbEngine">
              <span class="text-slate-300">Engine:</span>
              <span class="font-medium text-slate-100">{{ plan.dbEngine }}</span>
            </div>
            <div class="flex justify-between" *ngIf="plan.dbSize">
              <span class="text-slate-300">Size:</span>
              <span class="font-medium text-slate-100">{{ plan.dbSize }}</span>
            </div>
            <div class="flex justify-between" *ngIf="plan.dbCpu">
              <span class="text-slate-300">vCPU:</span>
              <span class="font-medium text-slate-100">{{ plan.dbCpu }}</span>
            </div>
            <div class="flex justify-between" *ngIf="plan.dbRam">
              <span class="text-slate-300">RAM:</span>
              <span class="font-medium text-slate-100">{{ plan.dbRam }}</span>
            </div>
          </div>
          
          <div class="mt-4 pt-3 border-t border-slate-800">
            <div class="flex justify-between text-sm">
              <span class="text-slate-300">Hourly:</span>
              <span class="font-semibold text-slate-100">₹{{ plan.hourlyPrice | number:'1.2-2' }}</span>
            </div>
            <div class="flex justify-between text-sm">
              <span class="text-slate-300">Monthly:</span>
              <span class="font-semibold text-slate-100">₹{{ plan.monthlyPrice | number:'1.2-2' }}</span>
            </div>
            <div class="flex justify-between text-sm">
              <span class="text-slate-300">Yearly:</span>
              <span class="font-semibold text-slate-100">₹{{ plan.yearlyPrice | number:'1.2-2' }}</span>
            </div>
            <div class="mt-2 text-xs text-indigo-300" *ngIf="getAnnualSavings(plan).percent > 0">
              Annual savings vs monthly: ₹{{ getAnnualSavings(plan).amount | number:'1.0-0' }} ({{ getAnnualSavings(plan).percent }}%)
            </div>
          </div>
          
          <div class="mt-4">
            <div class="mb-3">
              <label class="block text-sm font-medium text-slate-200 mb-1">Quantity</label>
              <input 
                type="number" 
                min="1" 
                max="100" 
                [(ngModel)]="plan.quantity" 
                (input)="updatePlanQuantity(plan.name, plan.quantity)" 
                class="w-full px-3 py-1 border border-slate-700 rounded-md bg-slate-950/70 text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm">
            </div>
            <div class="grid grid-cols-2 gap-3">
              <button 
                class="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-300 text-sm font-medium"
                (click)="selectAndAddPlan(plan)">
                Add to Estimate
              </button>
              <button
                class="w-full py-2 px-4 rounded-md border text-sm font-medium transition-colors duration-300"
                [ngClass]="isInCompare(plan) ? 'border-indigo-500 text-indigo-200 bg-indigo-950/40' : 'border-slate-700 text-slate-200 bg-slate-950/60 hover:bg-slate-900/70'"
                (click)="toggleCompare(plan)">
                {{ isInCompare(plan) ? 'Remove Compare' : 'Add to Compare' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Selected Plans Section -->
    <div class="bg-slate-900/70 rounded-xl shadow-2xl p-6 border border-slate-700/70 mb-8 backdrop-blur-sm" *ngIf="selectedPlans.length > 0">
      <h2 class="text-2xl font-bold text-white mb-6">Your Selected Plans</h2>
      
      <!-- Compute Services Section -->
      <div class="mb-8" *ngIf="getSelectedPlansByServiceType('compute').length > 0">
        <div class="bg-gradient-to-r from-blue-950/70 via-slate-900/70 to-indigo-950/70 px-4 py-3 rounded-lg mb-4">
          <h3 class="text-lg font-bold text-blue-200 flex items-center">
            <i class="bx bx-server mr-2 text-xl"></i>
            Compute Services
            <span class="ml-3 px-3 py-1 bg-blue-500 text-white text-xs font-semibold rounded-full">
              {{ getSelectedPlansByServiceType('compute').length }} {{ getSelectedPlansByServiceType('compute').length === 1 ? 'Plan' : 'Plans' }}
            </span>
          </h3>
        </div>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-slate-800">
            <thead class="bg-slate-900">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Plan</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Configuration</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Quantity</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Minimum Billing</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Price</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Total</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody class="bg-slate-900/40 divide-y divide-slate-800">
              <tr *ngFor="let item of getSelectedPlansByServiceType('compute')">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-medium text-slate-100">{{ item.plan.name }}</div>
                </td>
                <td class="px-6 py-4">
                  <div class="text-sm text-slate-300">
                    {{ item.plan.vcpu }} vCPU, {{ item.plan.ram }} RAM, {{ item.plan.storage }}
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-300">
                  {{ item.quantity }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-bold text-red-400">
                  <span *ngIf="item.plan.minimumBilling; else notApplicable">₹{{ item.plan.minimumBilling * item.quantity }}</span>
                  <ng-template #notApplicable>
                    <span class="text-slate-400">Not Applicable</span>
                  </ng-template>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-300">
                  <div *ngIf="calculator.selectedBilling === 'hourly'">₹{{ item.plan.hourlyPrice | number:'1.2-2' }}/hr</div>
                  <div *ngIf="calculator.selectedBilling === 'monthly'">₹{{ item.plan.monthlyPrice | number:'1.2-2' }}/mo</div>
                  <div *ngIf="calculator.selectedBilling === 'yearly'">₹{{ item.plan.yearlyPrice | number:'1.2-2' }}/yr</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-semibold text-slate-100">
                  <div *ngIf="calculator.selectedBilling === 'hourly'">₹{{ (item.plan.hourlyPrice * item.quantity) | number:'1.2-2' }}</div>
                  <div *ngIf="calculator.selectedBilling === 'monthly'">₹{{ (item.plan.monthlyPrice * item.quantity) | number:'1.2-2' }}</div>
                  <div *ngIf="calculator.selectedBilling === 'yearly'">₹{{ (item.plan.yearlyPrice * item.quantity) | number:'1.2-2' }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">
                  <button 
                    class="text-red-400 hover:text-red-300 font-medium"
                    (click)="removePlanFromEstimate(item.plan.name)">
                    <i class="bx bx-trash mr-1"></i>Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Storage Services Section -->
      <div class="mb-8" *ngIf="getSelectedPlansByServiceType('storage').length > 0">
        <div class="bg-gradient-to-r from-emerald-950/70 via-slate-900/70 to-green-950/70 px-4 py-3 rounded-lg mb-4">
          <h3 class="text-lg font-bold text-emerald-200 flex items-center">
            <i class="bx bx-data mr-2 text-xl"></i>
            Storage Services
            <span class="ml-3 px-3 py-1 bg-green-500 text-white text-xs font-semibold rounded-full">
              {{ getSelectedPlansByServiceType('storage').length }} {{ getSelectedPlansByServiceType('storage').length === 1 ? 'Plan' : 'Plans' }}
            </span>
          </h3>
        </div>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-slate-800">
            <thead class="bg-slate-900">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Plan</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Configuration</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Quantity</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Price</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Total</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody class="bg-slate-900/40 divide-y divide-slate-800">
              <tr *ngFor="let item of getSelectedPlansByServiceType('storage')">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-medium text-slate-100">{{ item.plan.name }}</div>
                </td>
                <td class="px-6 py-4">
                  <div class="text-sm text-slate-300">
                    {{ item.plan.storage }}, {{ item.plan.diskType }}, {{ item.plan.iops }} IOPS
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-300">
                  {{ item.quantity }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-300">
                  <div *ngIf="calculator.selectedBilling === 'hourly'">₹{{ item.plan.hourlyPrice | number:'1.2-2' }}/hr</div>
                  <div *ngIf="calculator.selectedBilling === 'monthly'">₹{{ item.plan.monthlyPrice | number:'1.2-2' }}/mo</div>
                  <div *ngIf="calculator.selectedBilling === 'yearly'">₹{{ item.plan.yearlyPrice | number:'1.2-2' }}/yr</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-semibold text-slate-100">
                  <div *ngIf="calculator.selectedBilling === 'hourly'">₹{{ (item.plan.hourlyPrice * item.quantity) | number:'1.2-2' }}</div>
                  <div *ngIf="calculator.selectedBilling === 'monthly'">₹{{ (item.plan.monthlyPrice * item.quantity) | number:'1.2-2' }}</div>
                  <div *ngIf="calculator.selectedBilling === 'yearly'">₹{{ (item.plan.yearlyPrice * item.quantity) | number:'1.2-2' }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">
                  <button 
                    class="text-red-400 hover:text-red-300 font-medium"
                    (click)="removePlanFromEstimate(item.plan.name)">
                    <i class="bx bx-trash mr-1"></i>Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Database Services Section -->
      <div class="mb-8" *ngIf="getSelectedPlansByServiceType('database').length > 0">
        <div class="bg-gradient-to-r from-purple-950/70 via-slate-900/70 to-fuchsia-950/70 px-4 py-3 rounded-lg mb-4">
          <h3 class="text-lg font-bold text-purple-200 flex items-center">
            <i class="bx bx-cylinder mr-2 text-xl"></i>
            Database Services
            <span class="ml-3 px-3 py-1 bg-purple-500 text-white text-xs font-semibold rounded-full">
              {{ getSelectedPlansByServiceType('database').length }} {{ getSelectedPlansByServiceType('database').length === 1 ? 'Plan' : 'Plans' }}
            </span>
          </h3>
        </div>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-slate-800">
            <thead class="bg-slate-900">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Plan</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Configuration</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Quantity</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Price</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Total</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody class="bg-slate-900/40 divide-y divide-slate-800">
              <tr *ngFor="let item of getSelectedPlansByServiceType('database')">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-medium text-slate-100">{{ item.plan.name }}</div>
                </td>
                <td class="px-6 py-4">
                  <div class="text-sm text-slate-300">
                    {{ item.plan.dbEngine }}, {{ item.plan.dbCpu }} vCPU, {{ item.plan.dbRam }} RAM
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-300">
                  {{ item.quantity }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-300">
                  <div *ngIf="calculator.selectedBilling === 'hourly'">₹{{ item.plan.hourlyPrice | number:'1.2-2' }}/hr</div>
                  <div *ngIf="calculator.selectedBilling === 'monthly'">₹{{ item.plan.monthlyPrice | number:'1.2-2' }}/mo</div>
                  <div *ngIf="calculator.selectedBilling === 'yearly'">₹{{ item.plan.yearlyPrice | number:'1.2-2' }}/yr</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-semibold text-slate-100">
                  <div *ngIf="calculator.selectedBilling === 'hourly'">₹{{ (item.plan.hourlyPrice * item.quantity) | number:'1.2-2' }}</div>
                  <div *ngIf="calculator.selectedBilling === 'monthly'">₹{{ (item.plan.monthlyPrice * item.quantity) | number:'1.2-2' }}</div>
                  <div *ngIf="calculator.selectedBilling === 'yearly'">₹{{ (item.plan.yearlyPrice * item.quantity) | number:'1.2-2' }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">
                  <button 
                    class="text-red-400 hover:text-red-300 font-medium"
                    (click)="removePlanFromEstimate(item.plan.name)">
                    <i class="bx bx-trash mr-1"></i>Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Cost Summary Section -->
    <div class="bg-gradient-to-r from-blue-950 via-slate-900 to-indigo-950 rounded-xl p-6 border border-blue-500/40 mb-8">
      <h2 class="text-2xl font-bold text-white mb-4 text-center">Cost Summary</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 text-center text-slate-100">
        <div class="bg-slate-900/70 rounded-lg p-4 shadow-lg border border-slate-700/70">
          <div class="text-sm text-slate-300">Hourly</div>
          <div class="text-2xl font-bold text-blue-400">₹{{ calculator.selectedBilling === 'hourly' ? (totalEstimateCost | number:'1.2-2') : (totalMonthlyCost ? (totalMonthlyCost / 720 | number:'1.2-2') : '0.00') }}</div>
        </div>
        <div class="bg-slate-900/70 rounded-lg p-4 shadow-lg border border-slate-700/70">
          <div class="text-sm text-slate-300">Monthly</div>
          <div class="text-2xl font-bold text-blue-400">₹{{ totalMonthlyCost | number:'1.2-2' }}</div>
        </div>
        <div class="bg-slate-900/70 rounded-lg p-4 shadow-lg border border-slate-700/70">
          <div class="text-sm text-slate-300">Yearly</div>
          <div class="text-2xl font-bold text-blue-400">₹{{ totalYearlyCost | number:'1.2-2' }}</div>
        </div>
      </div>
    </div>

    <!-- Action Buttons Section -->
    <div class="bg-slate-900/70 rounded-xl shadow-2xl p-6 border border-slate-700/70 backdrop-blur-sm">
      <h2 class="text-2xl font-bold text-white mb-4 text-center">Export Your Estimate</h2>
      <div class="flex flex-wrap justify-center gap-4">
        <button 
          class="px-6 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors duration-300 shadow-md"
          (click)="exportToPDF()">
          <i class="bx bx-file-pdf mr-2"></i>Export as PDF
        </button>
        <button 
          class="px-6 py-3 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 transition-colors duration-300 shadow-md"
          (click)="exportToExcel()">
          <i class="bx bx-file mr-2"></i>Export as Excel
        </button>
        <button 
          class="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors duration-300 shadow-md"
          (click)="printEstimate()">
          <i class="bx bx-printer mr-2"></i>Print Estimate
        </button>
        <button 
          class="px-6 py-3 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 transition-colors duration-300 shadow-md"
          (click)="openEmailForm()">
          <i class="bx bx-envelope mr-2"></i>Email Estimate
        </button>
        <button 
          class="px-6 py-3 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors duration-300 shadow-md"
          (click)="openLinkForm()">
          <i class="bx bx-link mr-2"></i>Copy Link
        </button>
      </div>
    </div>
  </div>

  <!-- Link Form Modal -->
  <div *ngIf="showLinkForm" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" id="link-modal">
    <div class="relative top-20 mx-auto p-5 border border-slate-700/50 shadow-lg rounded-md bg-slate-800/30 backdrop-blur-sm">
      <div class="mt-3">
        <div class="flex items-center justify-between pb-3">
          <h3 class="text-lg font-semibold text-white">Share Estimate Link</h3>
          <button class="text-slate-400 hover:text-slate-200" (click)="closeLinkForm()">
            <i class="bx bx-x text-2xl"></i>
          </button>
        </div>
        <div class="p-2">
          <div class="mb-4">
            <label class="block text-sm font-medium text-slate-200 mb-1">Full Link</label>
            <div class="flex">
              <input 
                type="text" 
                [value]="generatedLink" 
                readonly
                class="flex-1 px-3 py-2 border border-slate-700 rounded-l-md bg-slate-950/80 text-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <button 
                class="px-4 py-2 bg-blue-600 text-white rounded-r-md hover:bg-blue-700 transition-colors duration-300"
                (click)="copyLinkToClipboard('full')">
                Copy
              </button>
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium text-slate-200 mb-1">Shortened Link</label>
            <div class="flex">
              <input 
                type="text" 
                [value]="shortenedLink" 
                readonly
                class="flex-1 px-3 py-2 border border-slate-700 rounded-l-md bg-slate-950/80 text-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <button 
                class="px-4 py-2 bg-green-600 text-white rounded-r-md hover:bg-green-700 transition-colors duration-300"
                (click)="copyLinkToClipboard('shortened')">
                Copy
              </button>
            </div>
          </div>
        </div>
        <div class="flex justify-end pt-3">
          <button 
            class="px-4 py-2 bg-slate-600 text-white rounded-md hover:bg-slate-500 transition-colors duration-300"
            (click)="closeLinkForm()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Compare Modal -->
  <div *ngIf="showCompare" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" id="compare-modal">
    <div class="relative top-20 mx-auto p-5 border border-slate-700/70 shadow-lg rounded-md bg-slate-900/95 max-w-5xl w-11/12">
      <div class="mt-3">
        <div class="flex items-center justify-between pb-3">
          <h3 class="text-lg font-semibold text-white">Plan Comparison</h3>
          <button class="text-slate-400 hover:text-slate-200" (click)="closeCompare()">
            <i class="bx bx-x text-2xl"></i>
          </button>
        </div>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-slate-800">
            <thead class="bg-slate-900">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Plan</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Service</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Configuration</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Hourly</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Monthly</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">Yearly</th>
              </tr>
            </thead>
            <tbody class="bg-slate-900/40 divide-y divide-slate-800">
              <tr *ngFor="let p of compareSelection">
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="text-sm font-medium text-slate-100">{{ p.name }}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-slate-300">
                  {{ p.serviceType | titlecase }}
                </td>
                <td class="px-6 py-4 text-sm text-slate-300">
                  {{ getPlanConfigString(p) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-100">
                  ₹{{ p.hourlyPrice | number:'1.2-2' }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-100">
                  ₹{{ p.monthlyPrice | number:'1.2-2' }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-100">
                  ₹{{ p.yearlyPrice | number:'1.2-2' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- Email Form Modal -->
  <div *ngIf="showEmailForm" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" id="email-modal">
    <div class="relative top-20 mx-auto p-5 border border-slate-700/50 shadow-lg rounded-md bg-slate-800/30 backdrop-blur-sm">
      <div class="mt-3">
        <div class="flex items-center justify-between pb-3">
          <h3 class="text-lg font-semibold text-white">Send Estimate via Email</h3>
          <button class="text-slate-400 hover:text-slate-200" (click)="closeEmailForm()">
            <i class="bx bx-x text-2xl"></i>
          </button>
        </div>
        <div class="p-2">
          <label class="block text-sm font-medium text-slate-200 mb-1">Email Address</label>
          <input 
            type="email" 
            [(ngModel)]="recipientEmail" 
            placeholder="Enter recipient's email address" 
            class="w-full px-3 py-2 border border-slate-700 rounded-md bg-slate-950/80 text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>
        <div class="flex justify-end space-x-3 pt-3">
          <button 
            class="px-4 py-2 bg-slate-600 text-white rounded-md hover:bg-slate-500 transition-colors duration-300"
            (click)="closeEmailForm()">
            Cancel
          </button>
          <button 
            class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-300"
            (click)="emailEstimate()">
            Send Email
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
